/*
 GeoIPLookup performs a location lookup from the users IP. It uses our MaxMind
 database if possible, and if that doesn't work falls back to the new HTML5
 Geolocation (which requires a user to click an Allow button in their browser).
 You are expected to pass in callback functions to handle both success and failure
 cases:

 function successCallback(latitude, longitude, name)
 function errorCallback(error_message)
 */
import $ from '@rover/globals/jquery';

import geoHTML5Lookup from './geoHTML5Lookup';

export default (successCallback, errorCallback) => {
  const ajaxLookupUrl = '/ajax/geoip-lookup/';
  $.get(ajaxLookupUrl, result => {
    let name = '';
    if (result.status === 'success') {
      if (result.city && result.region) {
        name = `${result.city}, ${result.region}`;
      }
      if ($.isFunction(successCallback)) {
        successCallback(result.latitude, result.longitude, name);
      }
    } else {
      geoHTML5Lookup(successCallback, errorCallback);
    }
  });
};



// WEBPACK FOOTER //
// ./js/utilities/geoIPLookup.js